'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("itTreeTableNodeCell", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: ["^infiniTable", "^itTreeTableRow"],
    template: '<div class="it-tree-node-prefix"></div>',
    link: function link($scope, $el, $attrs, controllers) {
      var tableCtrl = controllers[0],
        config = tableCtrl.getConfig(),
        rendered = tableCtrl.getRenderer(),
        rowCtrl = controllers[1];
      if (config.showSpacers === false) {
        $el.addClass("no-spacers");
      }
      for (var i = 0; i <= $scope.depth; i++) {
        var spacerScope = $scope.$new();
        spacerScope.$spacerIdx = i;
        tableCtrl.linkers.spacer(spacerScope, function (spacer) {
          return spacer.appendTo($el);
        });
      }
      if (rendered.hasChildren(rowCtrl.getNode())) {
        tableCtrl.linkers.toggler($scope, function (toggler) {
          return toggler.appendTo($el);
        });
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/tree/itTreeTableNodeCell.js
// module id = 2821
// module chunks = 13